export default "__VITE_ASSET__0b2d4b48__"